import { useEffect, useRef, useState } from 'react'

import { IntroContainer } from 'components/intro-container'
import {
  Gradient,
  TitleContainer,
  Title,
  Subtitle,
} from 'components/intro-container/styled'
import backgroundL from './images/Background2_L.webp'
import backgroundM from './images/Background2_M.webp'
import backgroundS from './images/Background2_S.webp'
import hand1L from './images/Hand1_L.webp'
import hand2L from './images/Hand2_L.webp'
import hand3L from './images/Hand3_L.webp'
import hand1M from './images/Hand1_M.webp'
import hand2M from './images/Hand2_M.webp'
import hand3M from './images/Hand3_M.webp'
import hand1S from './images/Hand1_S.webp'
import hand2S from './images/Hand2_S.webp'
import hand3S from './images/Hand3_S.webp'
import feather1 from './images/Feather1.webp'
import feather2 from './images/Feather2.webp'
import feather3 from './images/Feather3.webp'
import feather4 from './images/Feather4.webp'
import feather5 from './images/Feather5.webp'
import feather6 from './images/Feather6.webp'
import feather7 from './images/Feather7.webp'
import birdL from './images/Bird_L.webp'
import birdM from './images/Bird_M.webp'
import birdS from './images/Bird_S.webp'
import sun from './images/Sun_L.webp'
import { AnimationContainer } from './styled'
import { useAppContext } from 'context/app-context'

export const Header = () => {
  const { setLoading, isPageVisible } = useAppContext()
  const [loadedImages, setLoadedImages] = useState(0)

  const startAnimation = () => {
    const refs = [
      handRef,
      birdRef,
      feather1Ref,
      feather2Ref,
      feather3Ref,
      feather4Ref,
      feather5Ref,
      feather6Ref,
      feather7Ref,
    ]

    refs.forEach((ref) => {
      ref.current?.classList.remove('start')
    })
    handRef.current?.classList.add('ani')
  }

  const onLoadImages = (e: React.SyntheticEvent<HTMLImageElement>) => {
    setLoadedImages((loadedImages) => loadedImages + 1)
    console.log(`Loaded: ${loadedImages} | Source: ${e.currentTarget.src}`)
  }

  const handRef = useRef<HTMLImageElement>(null)
  const hand1Ref = useRef<HTMLImageElement>(null)
  const hand2Ref = useRef<HTMLImageElement>(null)
  const hand3Ref = useRef<HTMLImageElement>(null)
  const birdRef = useRef<HTMLImageElement>(null)
  const feather1Ref = useRef<HTMLImageElement>(null)
  const feather2Ref = useRef<HTMLImageElement>(null)
  const feather3Ref = useRef<HTMLImageElement>(null)
  const feather4Ref = useRef<HTMLImageElement>(null)
  const feather5Ref = useRef<HTMLImageElement>(null)
  const feather6Ref = useRef<HTMLImageElement>(null)
  const feather7Ref = useRef<HTMLImageElement>(null)

  useEffect(() => {
    if (loadedImages === 12) {
      setLoading(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadedImages])

  useEffect(() => {
    if (isPageVisible) {
      startAnimation()
    }
  }, [isPageVisible])

  return (
    <IntroContainer>
      <AnimationContainer>
        <picture>
          <source
            srcSet={backgroundS}
            media="(max-width: 520px)"
            type="image/webp"
          />
          <source
            srcSet={backgroundM}
            media="(max-width: 1024px)"
            type="image/webp"
          />
          <img
            alt="background"
            className="background"
            src={backgroundL}
            onLoad={onLoadImages}
          />
        </picture>
        <img alt="sun" className="sun" src={sun} />
        <div ref={handRef} className="hand start">
          <picture>
            <source
              srcSet={hand1S}
              media="(max-width: 520px)"
              type="image/webp"
            />
            <source
              srcSet={hand1M}
              media="(max-width: 1024px)"
              type="image/webp"
            />
            <img
              alt="hand1"
              ref={hand1Ref}
              src={hand1L}
              onLoad={onLoadImages}
            />
          </picture>
          <picture>
            <source
              srcSet={hand2S}
              media="(max-width: 520px)"
              type="image/webp"
            />
            <source
              srcSet={hand2M}
              media="(max-width: 1024px)"
              type="image/webp"
            />
            <img
              alt="hand2"
              ref={hand2Ref}
              src={hand2L}
              onLoad={onLoadImages}
            />
          </picture>
          <picture>
            <source
              srcSet={hand3S}
              media="(max-width: 520px)"
              type="image/webp"
            />
            <source
              srcSet={hand3M}
              media="(max-width: 1024px)"
              type="image/webp"
            />
            <img
              alt="hand3"
              ref={hand3Ref}
              src={hand3L}
              onLoad={onLoadImages}
            />
          </picture>
        </div>
        <img
          alt="feather1"
          ref={feather1Ref}
          className="feather feather1 start"
          src={feather1}
          onLoad={onLoadImages}
        />
        <img
          alt="feather2"
          ref={feather2Ref}
          className="feather feather2 start"
          src={feather2}
          onLoad={onLoadImages}
        />
        <img
          alt="feather3"
          ref={feather3Ref}
          className="feather feather3 start"
          src={feather3}
          onLoad={onLoadImages}
        />
        <img
          alt="feather4"
          ref={feather4Ref}
          className="feather feather4 start"
          src={feather4}
          onLoad={onLoadImages}
        />
        <img
          alt="feather5"
          ref={feather5Ref}
          className="feather feather5 start"
          src={feather5}
          onLoad={onLoadImages}
        />
        <img
          alt="feather6"
          ref={feather6Ref}
          className="feather feather6 start"
          src={feather6}
          onLoad={onLoadImages}
        />
        <img
          alt="feather7"
          ref={feather7Ref}
          className="feather feather7 start"
          src={feather7}
          onLoad={onLoadImages}
        />
        <picture>
          <source srcSet={birdS} media="(max-width: 520px)" type="image/webp" />
          <source
            srcSet={birdM}
            media="(max-width: 1024px)"
            type="image/webp"
          />
          <img
            alt="bird"
            ref={birdRef}
            className="bird start"
            src={birdL}
            onLoad={onLoadImages}
          />
        </picture>
      </AnimationContainer>
      <Gradient />
      <TitleContainer $hidden={isPageVisible}>
        <Title className="home">ГОЛОСА СМЕЛЫХ</Title>
        <Subtitle>Проект против гендерного насилия в Центральной Азии</Subtitle>
      </TitleContainer>
    </IntroContainer>
  )
}
